    
    <div class="login-wrapper">
        <h2 translate>login.title</h2>
        <form #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate>
            <div>
                <label for="username" translate>login.login</label>
                <input name="username" ngModel required #first="ngModel">
            </div>
            <div>
                <label for="password" translate>login.password</label>
                <input type="password" name="password" ngModel>
            </div>
            <button class="btn btn-primary" translate>login.title</button>
        </form>
    </div>
